import React from 'react';

import { DatadogSessionReplayMask } from 'features/observability/rum/datadog-session-replay-mask';
import { StyleSheet } from 'react-native';
import { Typography } from 'ucl/components/text/Typography';

import { IServerOrder } from '@rbi-ctg/menu';
import { Box } from 'components/ui/box';
import { t } from 'state/intl/translations';
import { spacing } from 'styles/constants';

import { CardHeading, CardHeadingContainer, CardText } from '../styled';

const DeliveryInfo = ({ serverOrder }: { serverOrder: IServerOrder }) => {
  const { delivery, cart } = serverOrder;

  return (
    <CardHeadingContainer>
      <CardHeading>{t('deliveryInfo')}</CardHeading>

      <Box style={styles.detailsContainer}>
        <DatadogSessionReplayMask>
          <CardText testID="order-confirmation-customer-name" data-private>
            {cart.customerName}
          </CardText>
        </DatadogSessionReplayMask>
        <DatadogSessionReplayMask>
          <CardText testID="order-confirmation-dropoff-address" data-private>
            {`${delivery?.dropoff.addressLine1}\n`}
            {!!delivery?.dropoff.addressLine2 && (
              <>{`${t('unitNumber', { unitNumber: delivery?.dropoff.addressLine2 })}\n`}</>
            )}
            {delivery?.dropoff.city}, {delivery?.dropoff.state} {delivery?.dropoff.zip}
          </CardText>
        </DatadogSessionReplayMask>
        {!!delivery?.dropoff.phoneNumber && (
          <DatadogSessionReplayMask>
            <CardText testID="order-confirmation-phone-number" data-private>
              {delivery?.dropoff.phoneNumber}
            </CardText>
          </DatadogSessionReplayMask>
        )}
        {!!delivery?.instructions && (
          <DatadogSessionReplayMask>
            <CardText
              testID="order-confirmation-instructions"
              data-private
              style={{ marginTop: 4 }}
            >
              <Typography>{t('deliveryInstructions')}: </Typography>
              {`\n${delivery?.instructions}`}
            </CardText>
          </DatadogSessionReplayMask>
        )}
      </Box>
    </CardHeadingContainer>
  );
};

const styles = StyleSheet.create({
  detailsContainer: {
    marginTop: spacing.$4,
  },
});

export default DeliveryInfo;
